import React, { Component, useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import * as API from "../../core/service/api.js";
import {} from "../../core/feature/store";
import { useAppSelector, useAppDispatch } from "../../core/feature/hooks";
import {
  removeCompany,
  setCompany,
} from "../../core/feature/company/companySlice";
import logo from "../../assets/images/logo-default.svg";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import ellipse3 from "../../assets/images/icon_login/Ellipse3.svg";
import ellipse4 from "../../assets/images/icon_login/Ellipse4.svg";

import Company from "../../core/models/company";
import { setLoading } from "../../core/feature/config/configSlice";
import { setToken } from "../../core/feature/token/tokenSlice";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import User from "../../core/models/user.js";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import fingerPrint from "@fingerprintjs/fingerprintjs";
import Token from "../../core/models/token.js";
import { findIndex } from "lodash";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { createPassword, updatePassword } from "../../core/service/api_profile";
import { toast } from "react-toastify";
import eye from "../../assets/images/icon_login/eye.svg";
import eyeOff from "../../assets/images/icon_login/eyeclose.svg";
import { getUser } from "../../core/service/api_card.js";
import { removeBalance } from "../../core/feature/user/balanceSlice";

const CreatePasswordWeb = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const location: any = useLocation();
  const style = "min-h-screen h-full p-10 bg-psp-primary";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [inputActive, setInputActive] = useState(true);

  const [typeOldPassword, setTypeOldPassword] = useState("password");
  const [typeNewPassword, setTypeNewPassword] = useState("password");
  const [typeNew2Password, setTypeNew2Password] = useState("password");
  const [matchStatusPassword, setMatchStatusPassword] = useState("0");

  const user: User = useAppSelector((state) => state.user.user);
  const [data, setData] = useState<any>({});
  const updatePass = async () => {
    if (oldPassword == "")
      return toast.warning(t("CHANGE-PASSWORD.errorOldPass"));
    if (newPassword == "" || newPassword2 == "")
      return toast.warning(t("CHANGE-PASSWORD.errorNewPass"));
    if (newPassword != newPassword2)
      return toast.warning(t("CHANGE-PASSWORD.errorNotMatch"));

    const regexPassword = /^(?=.*[a-z])(?=.*\d)[a-zA-Z\d]{6,}$/;

    if (!newPassword.match(regexPassword) || !newPassword2.match(regexPassword))
      return toast.warning(t("LOGIN.passContain"));

    dispatch(setLoading(true));
    var query = {
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    updatePassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        toast.success(t("CHANGE-PASSWORD.success"));
        setOldPassword("");
        setNewPassword("");
        setNewPassword2("");
        setInputActive(true);
        var CryptoJS = require("crypto-js");
        var getCredential = localStorage.getItem("credential");
        var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
        var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        var data = decryptedData;
        data.password = newPassword
        var ciphertext = CryptoJS.AES.encrypt(
          JSON.stringify(data),
          "credential"
        ).toString();
        localStorage.setItem("credential", ciphertext);
        navigate("/home", {
          replace: true,
        });
      })
      .catch((err) => {
        dispatch(setLoading(false));
      });
  };
  const funTypePassword = async (type: string) => {
    switch (type) {
      case "old":
        if (typeOldPassword == "text") {
          setTypeOldPassword("password");
        } else {
          setTypeOldPassword("text");
        }
        break;
      case "new":
        if (typeNewPassword == "text") {
          setTypeNewPassword("password");
        } else {
          setTypeNewPassword("text");
        }
        break;
      default:
        if (typeNew2Password == "text") {
          setTypeNew2Password("password");
        } else {
          setTypeNew2Password("text");
        }
        break;
    }
  };
  const checkMatchPassword = useMemo(() => {
    if (newPassword != newPassword2) {
      setMatchStatusPassword("1");
    } else if (newPassword == "") {
      setMatchStatusPassword("0");
    } else {
      setMatchStatusPassword("2");
    }
  }, [newPassword, newPassword2]);
  return (
    <>
      <div className="relative font-poppins p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          <div className="w-1/3 sm:w-1/2 md:w-1/3 flex-0 bg-psp-login relative">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="mt-48 sm:mt-36 md:mt-48 flex flex-col items-start z-10 p-10 gap-8">
              <img src={logoWhite} className="z-10 h-14 select-none" />
              <p className="text-white z-10 mt-6 text-xs font-light">
                {t("LOGIN.description")}
              </p>
            </div>
          </div>
          <div className="flex w-full p-16 bg-psp-primary relative">
            <div className="px-4 pb-0 pt-12 z-10 w-full">
              <h1 className="text-gray-400 text-2xl font-medium select-none">
                Welcome To
              </h1>
              <p className="text-black font-semibold text-4xl select-none">
                PSP Web Dekstop
              </p>

              <div className=" pb-0 pt-6 mt-4 top-to-bottom">
                <h1 className="text-psp-primary m-0 text-xl font-bold">
                  {`${t("CREATE-PASSWORD.title")}`}
                </h1>
                <p className=" text-sm font-medium text-[#B9B9B9]">
                  {t("CREATE-PASSWORD.subtitle")}
                </p>

                <div className="flex flex-col">
                  <div className="mt-2 grow">
                    <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                      {t("CREATE-PASSWORD.oldPassword")}
                    </p>
                    <div className="relative w-full flex">
                      <input
                        type={typeOldPassword}
                        onChange={(e) => {
                          setOldPassword(e.target.value);
                        }}
                        className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid"
                      />
                      <img
                        src={typeOldPassword != "text" ? eyeOff : eye}
                        className="font-bold text-black absolute z-10 top-2 right-5"
                        onClick={() => funTypePassword("old")}
                      />
                    </div>
                  </div>
                  <div className="mt-2 grow">
                    <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                      {t("CREATE-PASSWORD.password")}
                    </p>
                    <div className="relative w-full flex">
                      <input
                        type={typeNewPassword}
                        onChange={(e) => (
                          setNewPassword(e.target.value), checkMatchPassword
                        )}
                        className="px-3 w-full rounded-xl h-10 border-1 border-psp-border-gray border-solid"
                      />
                      <img
                        src={typeNewPassword != "text" ? eyeOff : eye}
                        className="font-bold text-black absolute z-10 top-2 right-5"
                        onClick={() => funTypePassword("new")}
                      />
                    </div>
                  </div>
                  <div className="mt-2 grow">
                    <p className="text-sm font-medium text-[#B9B9B9] m-0 mb-1">
                      {t("CREATE-PASSWORD.retypePassword")}
                    </p>
                    <div className="relative w-full flex">
                      <input
                        type={typeNew2Password}
                        onChange={(e) => (
                          setNewPassword2(e.target.value), checkMatchPassword
                        )}
                        className={
                          matchStatusPassword == "2"
                            ? `bg-green-100 px-3 w-full rounded-xl h-10 border-1 border-green-300 border-solid`
                            : matchStatusPassword == "1"
                            ? `bg-red/10 px-3 w-full rounded-xl h-10 border-1 border-red/ border-solid`
                            : `px-3 w-full rounded-xl h-10 border-1 border-red/ border-solid`
                        }
                      />
                      <img
                        src={typeNew2Password != "text" ? eyeOff : eye}
                        className="font-bold text-black absolute z-10 top-2 right-5"
                        onClick={() => funTypePassword("new2")}
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  <button
                    onClick={() => updatePass()}
                    className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
                  >
                    {t("CREATE-PASSWORD.next")}
                  </button>
                  <button
                    onClick={() => navigate("/login", { replace: true })}
                    className="px-4 mt-2 bg-transparent border-[0.5px] border-solid border-[#0054E6] text-[#0054E6] font-bold text-sm items-center justify-center  w-full flex flex-row rounded-lg gap-3 py-2.5 active:bg-psp-active"
                  >
                    {t("OTHER.back")}
                  </button>
                </div>
              </div>
            </div>
            <img src={ellipse3} className="absolute top-0 -left-72 -z-0" />
            <img src={ellipse4} className="absolute bottom-0 right-0 -z-0" />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreatePasswordWeb;
